// File: frontend/src/components/Login.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import showModal from '../components/ui/modals/showModal';
import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [captcha, setCaptcha] = useState({ captchaId: null, svg: '' });
  const [captchaAnswer, setCaptchaAnswer] = useState('');
  const navigate = useNavigate();
  const { user, setUser } = useContext(AuthContext);

  useEffect(() => {
  if (user) {
    navigate('/');
  }
}, [user, navigate]);

  // Pobieramy wartości z .env
  const HOST = process.env.REACT_APP_HOST;
  const PORT = process.env.REACT_APP_API_PORT;
  // Budujemy URL do backendu
  const baseUrl = `https://${HOST}`;

  const fetchCaptcha = async () => {
    try {
      const { data } = await axios.get(`${baseUrl}/api/auth/captcha`);
      setCaptcha(data);
      setCaptchaAnswer('');
    } catch (err) {
      console.error('Nie udało się pobrać captchy:', err);
    }
  };

  useEffect(() => {
    fetchCaptcha();
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      // Wysyłamy żądanie POST z email i password
      const response = await axios.post(`${baseUrl}/api/auth/login`, {
        email,
        password,
        captchaId: captcha.captchaId,
        captchaAnswer
      });
      localStorage.setItem('token', response.data.token);

      setUser({
        id: response.data.id,
        email: response.data.email,
        username: response.data.username,
        role: response.data.role,
        regCarNum: response.data.regCarNum
      });

      navigate('/');
    } catch (err) {
      console.error(err);
      if (
        err.response?.status === 403 &&
        err.response.data?.reason === 'account_removed_due_to_domain'
      ) {
        showModal('Twoje konto zostało wyłączone w domenie Microsoft i zostało usunięte z aplikacji.', { type: 'error' });
      } else if (err.response?.data?.message?.toLowerCase().includes('captcha')) {
        showModal(err.response.data.message, { type: 'error' });
      } else {
        showModal('Błąd logowania. Upewnij się, że dane są poprawne.', { type: 'error' });
      }
      // Captcha jest jednorazowa - po każdej próbie (udanej czy nie) trzeba pobrać nową.
      fetchCaptcha();
    }
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: '50vh' }}
    >
      <div className="card p-4" style={{ maxWidth: '400px', width: '100%' }}>
        <h2 className="text-center mb-4">Logowanie</h2>

        <h5 className="mb-3">Logowanie lokalne</h5>
        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label htmlFor="emailInput">Email:</label>
            <input
              id="emailInput"
              type="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="passwordInput">Hasło:</label>
            <input
              id="passwordInput"
              type="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="captchaInput">Przepisz kod z obrazka:</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
              <div
                style={{ border: '1px solid #ccc', borderRadius: '4px', background: '#fff' }}
                dangerouslySetInnerHTML={{ __html: captcha.svg }}
              />
              <button
                type="button"
                onClick={fetchCaptcha}
                title="Odśwież obrazek"
                style={{
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  background: '#fff',
                  cursor: 'pointer',
                  padding: '6px 10px'
                }}
              >
                ↻
              </button>
            </div>
            <input
              id="captchaInput"
              type="text"
              className="form-control"
              value={captchaAnswer}
              onChange={(e) => setCaptchaAnswer(e.target.value)}
              autoComplete="off"
              required
            />
          </div>
          <button type="submit" className="btn btn-primary w-100"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#fff',
                border: '1px solid #ccc',
                borderRadius: '4px',
                marginBottom: '5px',
                padding: '8px 12px',
                fontSize: '15px',
                fontWeight: 500,
                color: '#000',
                cursor: 'pointer',
                boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
                gap: '8px',
                width: '100%'
              }}>
            Zaloguj
          </button>
        </form>

        <hr style={{ margin: '28px 0 20px' }} />

        <h5 className="mb-3">Logowanie przez Microsoft</h5>
        <button
          type="button"
          onClick={() => {
            const clientId = process.env.REACT_APP_MS_CLIENT_ID;
            const tenantId = process.env.REACT_APP_MS_TENANT_ID;
            const redirectUri = encodeURIComponent(process.env.REACT_APP_MS_REDIRECT_URI);
            const url = `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirectUri}&response_mode=query&scope=openid profile email`;

            window.location.href = url;
          }}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#fff',
            border: '1px solid #ccc',
            borderRadius: '4px',
            padding: '8px 12px',
            fontSize: '15px',
            fontWeight: 500,
            color: '#000',
            cursor: 'pointer',
            boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
            gap: '8px',
            width: '100%'
          }}
        >
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
            alt="Microsoft Logo"
            style={{ width: '20px', height: '20px' }}
          />
          Zaloguj się przez Microsoft
        </button>
      </div>
    </div>
  );
}

export default Login;
